import { RoleEnum } from "@/enums";
import type {
    ApiCompanyProfileType,
    ApiCompanyType,
    ApiExamRecommendedJobType,
    ApiInvitationType,
    ApiUserType,
    AuthUserType,
    CompanyProfileType,
    CompanyType,
    ExamRecommendedJobType,
    InvitationType,
} from "@/types";

export const transformApiUserHandler = ({
    company,
    company_id: companyId,
    created_at: createdAt,
    email,
    id,
    isIs_active: isActive,
    name,
    updated_at: updatedAt,
    user_type: userType,
}: ApiUserType): AuthUserType => ({
    companyId,
    companyName: company?.name,
    createdAt,
    email,
    id,
    isActive,
    name,
    phone: company?.phone,
    role: userType === RoleEnum.ADMIN ? RoleEnum.ADMIN : RoleEnum.COMPANY,
    updatedAt,
});

export const transformApiCompanyHandler = ({
    created_at: createdAt,
    disabled_at: disabledAt,
    email,
    id,
    isIs_enabled: isEnabled,
    name,
    phone,
    updated_at: updatedAt,
}: ApiCompanyType): CompanyType => ({
    createdAt,
    disabledAt,
    email,
    id,
    isEnabled: isEnabled ?? true,
    name,
    phone,
    updatedAt,
});

export const transformApiInvitationHandler = ({
    created_at: createdAt,
    email,
    expires_at: expiresAt,
    id,
    invited_by: invitedBy,
    status,
    used_at: acceptedAt,
}: ApiInvitationType): InvitationType => {
    const invitedByName = typeof invitedBy === "object" && invitedBy !== null ? invitedBy.name : undefined;

    return {
        acceptedAt,
        createdAt,
        email,
        expiresAt,
        id,
        invitedByName,
        status,
    };
};

export const transformApiCompanyProfileHandler = ({
    email,
    name,
    phone,
}: ApiCompanyProfileType): CompanyProfileType => ({
    companyName: name,
    email,
    name,
    phone: phone ?? "",
});

export const transformApiRecommendedJobHandler = ({
    job_title: jobTitle, // eslint-disable-line code-style/prop-naming-convention -- backend snake_case response
    justification,
}: ApiExamRecommendedJobType): ExamRecommendedJobType => ({
    jobTitle,
    justification,
});
